export default {
  adminEmail: '',
  fireBaseAuthError: '',
  isAdmin: false,
  packages: {},
  queriedUserProfile: null,
  userProfile: null
}